import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes, FaHeart, FaRegHeart } from 'react-icons/fa';
import './model.css';

const modelsData = [
  {
    id: 1,
    name: 'Jiya Soni',
    age: 19,
    city: 'Delhi',
    height: `5'2"`,
    hair: 'Black',
    eyes: 'Dark Brown',
    coverImage: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 2,
    name: 'Bhavyanshi Vats',
    age: 18,
    city: 'Delhi',
    height: `5'4"`,
    hair: 'Dark Brown',
    eyes: 'Brown',
    coverImage: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1496440737103-cd596325d314?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 3,
    name: 'Bhoomica Verma',
    age: 19,
    city: 'Delhi',
    height: `5'5"`,
    hair: 'Black',
    eyes: 'Hazel',
    coverImage: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 4,
    name: 'Ananya Sharma',
    age: 23,
    city: 'Mumbai',
    height: `5'6"`,
    hair: 'Brown',
    eyes: 'Dark Brown',
    coverImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=900&auto=format&fit=crop&q=80',
   
    'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=900&auto=format&fit=crop&q=80',
    ],
  },
];

function FemaleModel() {
  const [selectedModel, setSelectedModel] = useState(null);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);
  const [shortlisted, setShortlisted] = useState([]);

  // Open modal
  const openModelViewer = (model) => {
    setSelectedModel(model);
    setActivePhotoIndex(0);
  };

  // Close modal
  const closeModelViewer = () => {
    setSelectedModel(null);
  };

  // Manual Previous Slide
  const handlePrev = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === 0 ? selectedModel.photos.length - 1 : prev - 1
    );
  };

  // Manual Next Slide
  const handleNext = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === selectedModel.photos.length - 1 ? 0 : prev + 1
    );
  };

  // Toggle Shortlist
  const toggleShortlist = (id) => {
    setShortlisted((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div className="female-model-page">
      <div className="page-container">
        <header className="page-header">
          <h1 className="page-title">Female Models</h1>
          <p className="page-desc">
            At CastYou, browse through individual portfolios of professional models. Click on any model to view high-resolution photographs and full profile specifications.
          </p>
        </header>

        {/* Grid List */}
        <div className="models-grid">
          {modelsData.map((model) => (
            <div
              key={model.id}
              className="model-card"
              onClick={() => openModelViewer(model)}
            >
              <div className="card-image-wrapper">
                <img src={model.coverImage} alt={model.name} className="model-img" />
              </div>
              <div className="model-info">
                <span className="model-name">
                  {model.name} ( AGE {model.age} )
                </span>
                <span className="model-city">{model.city}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FULL WINDOW LIGHTBOX MODAL */}
      {selectedModel && (
        <div className="modal-backdrop" onClick={closeModelViewer}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="modal-close-btn" onClick={closeModelViewer}>
              <FaTimes />
            </button>

            {/* Split Top View: Image Slider (Left) & Details (Right) */}
            <div className="modal-split-body">
              {/* Left Side: Manual Image Slider */}
              <div className="slider-container">
                <button className="slider-arrow left-arrow" onClick={handlePrev} aria-label="Previous">
                  <FaChevronLeft />
                </button>
                <div className="slider-image-frame">
                  <img
                    src={selectedModel.photos[activePhotoIndex]}
                    alt={`${selectedModel.name} slide`}
                    className="slider-main-img"
                  />
                </div>
                <button className="slider-arrow right-arrow" onClick={handleNext} aria-label="Next">
                  <FaChevronRight />
                </button>
              </div>

              {/* Right Side: Model Details */}
              <div className="details-container">
                <div className="details-header">
                  <h2 className="details-name">{selectedModel.name}</h2>
                  <span className="details-city">{selectedModel.city}</span>
                </div>

                <div className="details-specs">
                  <div className="spec-row">
                    <span>Age</span>
                    <strong>{selectedModel.age}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Height</span>
                    <strong>{selectedModel.height}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Hair</span>
                    <strong>{selectedModel.hair}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Eyes</span>
                    <strong>{selectedModel.eyes}</strong>
                  </div>
                </div>

                <div className="details-actions">
                  <button
                    className="shortlist-btn"
                    onClick={() => toggleShortlist(selectedModel.id)}
                  >
                    {shortlisted.includes(selectedModel.id) ? (
                      <>
                        <FaHeart className="heart-icon-filled" /> Shortlisted
                      </>
                    ) : (
                      <>
                        <FaRegHeart /> Shortlist Model
                      </>
                    )}
                  </button>
                  <button className="enquire-btn">Enquire About Artist</button>
                </div>
              </div>
            </div>

            {/* Bottom Next Line: Thumbnails Carousel */}
            <div className="modal-thumbnails-bar">
              <span className="thumbnails-title">
                Photos ({activePhotoIndex + 1} / {selectedModel.photos.length}):
              </span>
              <div className="thumbnails-track">
                {selectedModel.photos.map((photo, index) => (
                  <div
                    key={index}
                    className={`thumbnail-item ${index === activePhotoIndex ? 'active-thumb' : ''}`}
                    onClick={() => setActivePhotoIndex(index)}
                  >
                    <img src={photo} alt="thumbnail" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FemaleModel;